import {useEffect, useState} from 'react'
import {AuthService} from 'rest'

const useUser = () => {
  const [user, setUser] = useState<any>(
    JSON.parse(localStorage.getItem('user') || '{}')
  )

  const fetchUser = async () => {
    try {
      const response = await AuthService.getAuthUser()
      setUser(response.data)
    } catch (error) {}
  }

  useEffect(() => {
    fetchUser()
  }, [])

  return {
    user,
    setUser,
  }
}
export default useUser
